import React from "react"
import { Link } from "gatsby"
/**
 * Legal Component, copyright etc.
 * @param {object} props - react props
 * @param {object} props.style - style from parent SCSS module
 * @param {object} props.data - content data
 */
const Legal = ({ style, data }) => {
  const { POLICY_PRIVACY, POLICY_COOKIE, POLICY_SOCIAL } = data
  const year = new Date().getFullYear()
  return (
    <div className={style.legal}>
      <div className={style.copyright}>&copy; {year}, Exo Imaging, Inc</div>
      <ul className={style.links}>
        <li>
          <Link to={POLICY_PRIVACY}>Privacy Policy</Link>
        </li>
        <li>
          <Link to={POLICY_COOKIE}>Cookie Policy</Link>
        </li>
        <li>
          <Link to={POLICY_SOCIAL}>Social Policy</Link>
        </li>
      </ul>
    </div>
  )
}

export default Legal
